<div class="modal-body">
    <a class="mt-1 float-right" (click)="hideNavModal()" title="Image"><i class="icon-close"></i></a>
    <form id="siteForm" appPromptUnsubmitted (ngSubmit)="save()">
        <div class="card-body">
            <h5 class="form-group col-sm-12" *ngIf="!isEditSpecies">
               Add Tree Species
            </h5>
            <h5 class="form-group col-sm-12" *ngIf="isEditSpecies">
               Edit Tree Species
            </h5>
            <div class="form-group col-12">
                    <label for="name">Name</label>
                    <input 
                    class="form-control is-invalid"
                    id="name"
                    name="name"
                    type="text"
                    [appIsInvalid]="!treeSpecies.species"
                    [(ngModel)]="treeSpecies.species" />

                    <div class="invalid-feedback" *ngIf="!treeSpecies.species">
                        Name is Required.
                    </div>
            </div>

            <div class="form-group col-md-12">
                    <label for="name">Description</label>

                    <textarea class="form-control"
                        id="description" name="description"  [(ngModel)]="treeSpecies.description" [appIsInvalid]="!treeSpecies.description" rows="3" required></textarea>
                    <div class="invalid-feedback">
                        Description is Required.
                    </div>
            </div>

            <div class="form-group col-md-12">
                    <label for="name">Image</label>

                    <app-photo-upload  [existingPhotoUrl]="treeSpecies.photoUrl"  (photoSelected)="onPhotoSelected($event)">
                    </app-photo-upload>
            </div>

            <div class="row mt-5">
                <div class="col-md-12 text-center">
                    <button class="btn btn-primary mr-3">Save</button>
                    <button type="button" class="btn btn-outline-dark" (click)="hideNavModal()">Cancel</button>
                </div>

            </div>
        </div>
    </form>
</div>


